<script>
    import {fade} from 'svelte/transition';
    import R, {LOADER} from "../../lib/requests";
    import app  from "../../stores/app";
    import user from "../../stores/user";
    import Alert from "../../stores/alerts";
    import {setFocusTo} from "../../lib/lib";
    import AppIcon from "../icons/AppIcon.svelte";

    let email = '';
    let error = false;
    let completed = false;
    // let actionRequestLink = null;

    const submit = () => {

        const onSuccess = result => {
            completed = true;
            // actionRequestLink = result;
            if ($app.debugNotifications) {
                Alert.alert("DEBUG!!!", `Member gets this link to his email:\n<a href="${result}" target="_blank">${result}</a>`);
            }
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                error = "We couldn't find a member account with the email you provided!";
                setFocusTo('memberEmail');
            }
        };

        error = null;
        let data = {
            action: 'reset-password',
            data: email,
        }

        R.handle(R.actionRequest.request, data, onSuccess, onFailure, LOADER.POPUP);
    }

    // const sendMail = () => {
    //     const onSuccess = result => {
    //
    //     }
    //
    //     const onFailure = err => {
    //
    //     };
    //
    //
    //     let data = {
    //         action: 'reset-password',
    //         email,
    //         link: actionRequestLink,
    //     }
    //
    //     R.handle(R.apiRequest.sendMail, data, onSuccess, onFailure, LOADER.POPUP);
    // }

    setFocusTo('memberEmail');
</script>

<div class="password-overlay" transition:fade="{{ duration: 100 }}">
    <div class="close-page" on:click={ user.hideForgotPassword }>
        <AppIcon icon="x" size="24" strokeWidth="2"/>
    </div>
    <div class="password-content">
        <div class="panel-simple panel-password box-shadow rounded">
            <h2 class="line-height-1 mb-3">Forgot your password?</h2>
            <p class="mb-4">
                Enter your account email and we'll send you instructions on how to change your password.
            </p>

            {#if !completed}
                <form on:submit|preventDefault|stopPropagation="{ submit }">
                    <div class="form-group">
                        <input type="email" class="form-control" id="memberEmail" bind:value="{ email }"
                               placeholder="email" required>
                    </div>
                    {#if error}
                        <div class="text-danger fw-semibold mb-4">
                            { error }
                        </div>
                    {/if}
                    <button class="btn btn-primary btn-block rounded mb-4">Submit</button>
                </form>
            {:else}
                <hr class="fat">
                <p>
                    Please check your mail for instructions on how to change your account password.
                </p>
            {/if}

            <div class="text-center">
                <button class="btn btn-link" on:click={ user.showLogin }>Back to sign in</button>
            </div>
        </div>
    </div>
</div>

<style>
    .password-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: var(--body-background);
        z-index: 9000;
    }

    .password-content {
        position: absolute;
        width: 95%;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }

    .panel-password {
        max-width: 400px;
        padding: 2rem;
        margin: auto;
    }

    .close-page {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 35px;
        padding: 10px;
        line-height: 1;
        border-radius: 50%;
        cursor: pointer;
    }
    .close-page:hover {
        color: #000;
        background: #ebebeb;
    }
</style>